// extracted by mini-css-extract-plugin
module.exports = {"partnerBtnCN":"PartnerBtnCN_partnerBtnCN__ONgbt"};